import React, { Component } from "react";
import { ajaxWrapper, resolveVariables, run_functions } from "functions";
import { Modal, NumberInput, TextInput, Select, CSSInput, Function_Input } from "library";
//<Button type={'success'} text={'Add New Event'} href={'/newEvent/'} />

var BOOLEANS = [
	{ text: "True", value: true },
	{ text: "False", value: false },
];

var BUTTON_TYPES = [
	{ text: "primary", value: "primary" },
	{ text: "secondary", value: "secondary" },
	{ text: "success", value: "success" },
	{ text: "danger", value: "danger" },
	{ text: "warning", value: "warning" },
	{ text: "info", value: "info" },
	{ text: "light", value: "light" },
	{ text: "dark", value: "dark" },
	{ text: "link", value: "link" },
	{ text: "outline-primary", value: "outline-primary" },
	{ text: "outline-secondary", value: "outline-secondary" },
	{ text: "outline-success", value: "outline-success" },
	{ text: "outline-danger", value: "outline-danger" },
	{ text: "outline-warning", value: "outline-warning" },
	{ text: "outline-info", value: "outline-info" },
	{ text: "outline-light", value: "outline-light" },
	{ text: "outline-dark", value: "outline-dark" },
];

class Button extends React.Component {
	static component_name = "Button";
	constructor(props) {
		super(props);

		this.state = {
			modal: false,
			hover: false,
		};

		this.showModal = this.showModal.bind(this);
		this.hideModal = this.hideModal.bind(this);
		this.click = this.click.bind(this);
	}

	showModal() {
		this.setState({ modal: true });
	}

	hideModal() {
		this.setState({ modal: false });
	}

	click(e) {
		e.preventDefault();
		if (this.props.href) {
			if (this.props.target == "_blank") {
				window.open(this.props.href, "_blank");
			} else {
				window.location.href = this.props.href;
			}
		} else if (this.props.onClick) {
			this.props.onClick(e);
		} else if (this.props.parent_functions) {
			for (var i in this.props.parent_functions) {
				this.props.parent_functions[i](e);
			}
		}
		if (this.props.functions) {
			run_functions(this.props.functions, this.setState, this.props.setGlobalState);
		}

		this.hideModal();
	}

	render() {
		var type = "btn btn-" + this.props.type;
		var className = type + " " + this.props.className;

		var style = {};
		if (this.props.style) {
			style = this.props.style;
		}

		var hover = null;
		if (this.props.hover) {
			var hoverCSS = {
				position: "absolute",
				top: "0px",
				right: "0px",
				padding: "2px 10px",
				margin: "2px",
				borderRadius: "100px",
				background: "#c82333",
			};

			var props = {
				onMouseEnter: this.onMouseEnter.bind(this),
				onMouseLeave: this.onMouseLeave.bind(this),
			};

			if (this.state.hover) {
				hover = (
					<div className="hoverClose" style={hoverCSS}>
						x
					</div>
				);
			}
		}

		let text = this.props.children;
		if (!text) {
			text = this.props.text;
		}

		if (this.props.disabled) {
			var content = (
				<button className={className} onClick={this.click} style={style} disabled>
					{text}
				</button>
			);
		} else {
			if (this.props.href) {
				var content = (
					<a className={className} href={this.props.href} style={style} target={this.props.target}>
						{text}
					</a>
				);
			} else {
				var content = (
					<button className={className} onClick={this.click} style={style}>
						{text}
					</button>
				);
			}
		}

		if (this.props.deleteType == true && this.state.modal == false) {
			return content;
		} else if (this.props.deleteType == true && this.state.modal == true) {
			var alt = (
				<button className={"btn btn-success"} onClick={this.hideModal} style={{ margin: "15px" }}>
					Don't Delete
				</button>
			);
			var button = (
				<button className={className} onClick={this.click} style={style}>
					{text}
				</button>
			);
			return <Modal content={[alt, button]} show={true} title={"Are you sure?"} onHide={this.hideModal} />;
		} else {
			return content;
		}
	}
}

export default Button;
